import { render, staticRenderFns } from "./IconCheck.vue?vue&type=template&id=70410b6d&scoped=true&"
import script from "./IconCheck.vue?vue&type=script&lang=js&"
export * from "./IconCheck.vue?vue&type=script&lang=js&"
import style0 from "./IconCheck.vue?vue&type=style&index=0&id=70410b6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70410b6d",
  null
  
)

export default component.exports